module.exports = "<a href=\"#\" class=\"badge badge-primary\">Primary</a>\n<a href=\"#\" class=\"badge badge-secondary\">Secondary</a>\n<a href=\"#\" class=\"badge badge-success\">Success</a>\n<a href=\"#\" class=\"badge badge-danger\">Danger</a>\n<a href=\"#\" class=\"badge badge-warning\">Warning</a>\n<a href=\"#\" class=\"badge badge-info\">Info</a>\n<a href=\"#\" class=\"badge badge-light\">Light</a>\n<a href=\"#\" class=\"badge badge-dark\">Dark</a>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/components/Badge/BadgeLinks.html
// module id = 378
// module chunks = 0